import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2d7bf05e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    class: "relative flex flex-col items-center justify-center w-full h-full bg-gray-100 rounded-lg dark:bg-gray-700",
    style: { "grid-row-end": "span 10" }
};
const _hoisted_2 = { class: "flex flex-col items-center w-full h-full" };
const _hoisted_3 = ["src"];
const _hoisted_4 = /*#__PURE__*/ _createStaticVNode("<defs data-v-2d7bf05e><filter id=\"a\" width=\"126.7%\" height=\"147.1%\" x=\"-11.7%\" y=\"-20.6%\" filterUnits=\"objectBoundingBox\" data-v-2d7bf05e><feOffset dx=\"2\" dy=\"2\" in=\"SourceAlpha\" result=\"shadowOffsetOuter1\" data-v-2d7bf05e></feOffset><feGaussianBlur in=\"shadowOffsetOuter1\" result=\"shadowBlurOuter1\" stdDeviation=\"5\" data-v-2d7bf05e></feGaussianBlur><feColorMatrix in=\"shadowBlurOuter1\" values=\"0 0 0 0 0.858823529 0 0 0 0 0.858823529 0 0 0 0 0.858823529 0 0 0 1 0\" data-v-2d7bf05e></feColorMatrix></filter><path id=\"b\" d=\"M4 0h112c2.21 0 4 1.79 4 4v52c0 6.627-5.373 12-12 12H4c-2.21 0-4-1.79-4-4V4c0-2.21 1.79-4 4-4z\" data-v-2d7bf05e></path></defs><g fill=\"none\" fill-rule=\"evenodd\" data-v-2d7bf05e><path stroke=\"#DDDBEA\" stroke-dasharray=\"6 5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M42 31h112c2.21 0 4 1.79 4 4v60c0 2.21-1.79 4-4 4H42c-2.21 0-4-1.79-4-4V35c0-2.21 1.79-4 4-4z\" opacity=\".5\" style=\"mix-blend-mode:multiply;\" data-v-2d7bf05e></path><g transform=\"rotate(-2 350.95 -218.805)\" data-v-2d7bf05e><use fill=\"#000\" fill-rule=\"nonzero\" filter=\"url(#a)\" xlink:href=\"#b\" data-v-2d7bf05e></use><path fill=\"#FFF\" d=\"M4 0h112c2.21 0 4 1.79 4 4v52c0 6.627-5.373 12-12 12H4c-2.21 0-4-1.79-4-4V4c0-2.21 1.79-4 4-4z\" data-v-2d7bf05e></path><path stroke=\"#FFB616\" stroke-linecap=\"round\" stroke-width=\"2\" d=\"M16 19.434c2.63.339 5.299 1.577 7.89 1.015 5.451-1.183 8.904-8.842 12.153-.865.752 1.845-2.104 4.412-3.465 3.017-3.94-4.042 7.727-4.5 8.422-4.402\" style=\"mix-blend-mode:multiply;\" data-v-2d7bf05e></path><path stroke=\"#DDDBEA\" stroke-width=\"2\" style=\"mix-blend-mode:multiply;\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M15.311 49.908h66m-65.864-8.304h88.889M15.556 32.5h88.888\" data-v-2d7bf05e></path><path fill=\"#F7F7FF\" d=\"M108 56h12c0 6.627-5.373 12-12 12V56z\" data-v-2d7bf05e></path><path fill=\"#FFB616\" fill-rule=\"nonzero\" d=\"M4 0v68c-2.21 0-4-1.79-4-4V4c0-2.21 1.79-4 4-4z\" data-v-2d7bf05e></path></g></g>", 2);
const _hoisted_6 = [
    _hoisted_4
];
const _hoisted_7 = ["src"];
const _hoisted_8 = /*#__PURE__*/ _createStaticVNode("<defs data-v-2d7bf05e><filter id=\"a\" width=\"126.7%\" height=\"147.1%\" x=\"-11.7%\" y=\"-20.6%\" filterUnits=\"objectBoundingBox\" data-v-2d7bf05e><feOffset dx=\"2\" dy=\"2\" in=\"SourceAlpha\" result=\"shadowOffsetOuter1\" data-v-2d7bf05e></feOffset><feGaussianBlur in=\"shadowOffsetOuter1\" result=\"shadowBlurOuter1\" stdDeviation=\"5\" data-v-2d7bf05e></feGaussianBlur><feColorMatrix in=\"shadowBlurOuter1\" values=\"0 0 0 0 0.101960784 0 0 0 0 0.11372549 0 0 0 0 0.129411765 0 0 0 1 0\" data-v-2d7bf05e></feColorMatrix></filter><path id=\"b\" d=\"M4 0h112c2.21 0 4 1.79 4 4v52c0 6.627-5.373 12-12 12H4c-2.21 0-4-1.79-4-4V4c0-2.21 1.79-4 4-4z\" data-v-2d7bf05e></path></defs><g fill=\"none\" fill-rule=\"evenodd\" data-v-2d7bf05e><path stroke=\"#DDDBEA\" stroke-dasharray=\"6 5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M42 31h112c2.21 0 4 1.79 4 4v60c0 2.21-1.79 4-4 4H42c-2.21 0-4-1.79-4-4V35c0-2.21 1.79-4 4-4z\" opacity=\".5\" style=\"mix-blend-mode:multiply;\" data-v-2d7bf05e></path><g transform=\"rotate(-2 350.95 -218.805)\" data-v-2d7bf05e><use fill=\"#000\" fill-rule=\"nonzero\" filter=\"url(#a)\" xlink:href=\"#b\" data-v-2d7bf05e></use><path fill=\"#1A1D21\" d=\"M4 0h112c2.21 0 4 1.79 4 4v52c0 6.627-5.373 12-12 12H4c-2.21 0-4-1.79-4-4V4c0-2.21 1.79-4 4-4z\" data-v-2d7bf05e></path><path stroke=\"#6284D6\" stroke-linecap=\"round\" stroke-width=\"2\" d=\"M16 19.434c2.63.339 5.299 1.577 7.89 1.015 5.451-1.183 8.904-8.842 12.153-.865.752 1.845-2.104 4.412-3.465 3.017-3.94-4.042 7.727-4.5 8.422-4.402\" data-v-2d7bf05e></path><path stroke=\"#ABABAD\" stroke-width=\"2\" style=\"mix-blend-mode:multiply;\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M15.311 49.908h66m-65.864-8.304h88.889M15.556 32.5h88.888\" data-v-2d7bf05e></path><path fill=\"#121016\" d=\"M108 56h12c0 6.627-5.373 12-12 12V56z\" data-v-2d7bf05e></path><path fill=\"#6284D6\" fill-rule=\"nonzero\" d=\"M4 0v68c-2.21 0-4-1.79-4-4V4c0-2.21 1.79-4 4-4z\" data-v-2d7bf05e></path></g></g>", 2);
const _hoisted_10 = [
    _hoisted_8
];
const _hoisted_11 = { class: "mt-6" };
const _hoisted_12 = {
    key: 1,
    class: "h-8 font-medium text-gray-500 dark:text-gray-300 text-md"
};
import componentI18n from '@/i18n/componentI18n';
const __default__ = {
    ...componentI18n('components.groups')
};
import { computed, onMounted, ref } from 'vue';
import { storeToRefs } from 'pinia';
import Draggable from 'vuedraggable';
import { useRetroStore } from '@/pinia_stores/retro';
import transitions from '@/helpers/transitions';
export default /*#__PURE__*/ _defineComponent({
    ...__default__,
    __name: 'NewGroup',
    setup(__props) {
        const retroStore = useRetroStore();
        const { topicBeingShared, isCurrentUserPosting, phase, sharingMode } = storeToRefs(retroStore);
        const { assignTopicToNewGroup } = retroStore;
        const hovered = ref(false);
        const drag = ref();
        const sharingThroughButton = computed(() => phase.value === 'posting' && isCurrentUserPosting.value && sharingMode.value === 'button');
        onMounted(() => {
            drag.value.$el.addEventListener('dragover', () => hover());
            drag.value.$el.addEventListener('dragleave', () => undoHover());
        });
        function hover() {
            hovered.value = true;
        }
        function undoHover() {
            hovered.value = false;
        }
        function handleDrop(event) {
            const topicId = parseInt(event.item.attributes.id.value);
            assignTopicToNewGroup(topicId);
            undoHover();
        }
        const { scaleIn, scaleOut } = transitions.scale;
        return (_ctx, _cache) => {
            const _component_pill_button = _resolveComponent("pill-button");
            const _component_transition_a11y = _resolveComponent("transition-a11y");
            return (_openBlock(), _createElementBlock("li", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    (_openBlock(), _createElementBlock("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        "xmlns:xlink": "http://www.w3.org/1999/xlink",
                        width: "159",
                        height: "100",
                        viewBox: "0 0 159 100",
                        "svg-inline": '',
                        src: '@/assets/images/drag-here-image.svg',
                        class: _normalizeClass('mt-4 dark:hidden'),
                        alt: 'Drag here'
                    }, _hoisted_6, 8, _hoisted_3)),
                    (_openBlock(), _createElementBlock("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        "xmlns:xlink": "http://www.w3.org/1999/xlink",
                        width: "159",
                        height: "100",
                        viewBox: "0 0 159 100",
                        "svg-inline": '',
                        src: '@/assets/images/drag-here-image-dark.svg',
                        class: _normalizeClass('hidden mt-4 dark:block'),
                        alt: 'Drag here'
                    }, _hoisted_10, 8, _hoisted_7)),
                    _createElementVNode("div", _hoisted_11, [
                        _createVNode(_component_transition_a11y, {
                            css: false,
                            onEnter: _unref(scaleIn),
                            onLeave: _unref(scaleOut)
                        }, {
                            default: _withCtx(() => [
                                (_unref(sharingThroughButton))
                                    ? (_openBlock(), _createBlock(_component_pill_button, {
                                        key: 0,
                                        onClick: _cache[0] || (_cache[0] = ($event) => (_unref(assignTopicToNewGroup)(_unref(topicBeingShared).id)))
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t('add_to_new_group')), 1)
                                        ], undefined, true),
                                        _: 1
                                    }))
                                    : (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(_ctx.$t('drag_here_new_group')), 1))
                            ], undefined, true),
                            _: 1
                        }, 8, ["onEnter", "onLeave"])
                    ]),
                    _createVNode(_unref(Draggable), {
                        ref_key: "drag",
                        ref: drag,
                        list: [],
                        "item-key": 'key',
                        group: "dragTopics",
                        class: _normalizeClass({
                            'absolute top-0 left-0 w-full h-full rounded-lg': !_unref(sharingThroughButton),
                            'bg-primary-700 opacity-70': hovered.value
                        }),
                        "ghost-class": "hidden",
                        tag: "div",
                        handle: ".handle",
                        onAdd: handleDrop,
                        onDragover: hover
                    }, {
                        item: _withCtx(({ element }) => [
                            (_openBlock(), _createElementBlock("div", {
                                key: element.id,
                                class: "hidden"
                            }))
                        ]),
                        _: 1
                    }, 8, ["class"])
                ])
            ]));
        };
    }
});
